<template>
  <div class="activity" @click="loadActivity"
       :class="[styleType, styleType? questTypeClassBackground(activity.quest?.type): '', interactable? 'pointer' : '']">
    <div class="icon-container d-flex align-items-center justify-content-center"
         :class="questTypeClassBackground(activity.quest?.type)">
      <!--<QuestTypeIcon class="quest-type-icon" :quest-type="activity.quest?.type"/>-->
      <SymbolIcon :iconName="activity.quest?.type" :color="'white'"
                  :hoverName="PrettyName[activity.quest?.type]"></SymbolIcon>

    </div>
    <div class="title">
    <span class="timestamp" v-show="!hideTimestamp">
      {{ formattedTime }}
    </span>
      <span v-if="styleType !== 'full-color'">
        <template v-if="hideTitle">
          {{ questTypeToString(activity.quest?.type) }}
        </template>
        <template v-else>
          {{ activity.quest?.title }}
        </template>
      </span>
      <!--Todo: (lm) This is kind of dirty, make the little activity type bar it's own component -->
      <span v-if="styleType === 'full-color'">
        {{ questTypeToString(activity.type) }}
      </span>
    </div>
    <div class="score d-flex align-items-center justify-content-center">
      {{ activity.quest?.points }}&nbsp;<BatteryLogo v-if="!hideStar" class="energy-icon"/>
      <NewActivityIcon v-if="recentActivity" :show="true" :color="'red'"></NewActivityIcon>
    </div>
  </div>
</template>

<script>
import QuestTypeHelper from "@/mixins/QuestTypeHelper";
import DateFormatter from "@/mixins/DateFormatter";

import BatteryLogo from "@/assets/image/icons/quest/icon-activity_points.svg?inline";
import SymbolIcon from "@/components/UI/SymbolIcon.vue";
//import NewActivityIcon from "@/components/UI/NewActivityIcon.vue";
import {PrettyName} from "@/enums/PrettyName";
import NewActivityIcon from "@/components/UI/NewActivityIcon.vue";

export default {
  name: "ActivitySmall",
  components: {NewActivityIcon, SymbolIcon, BatteryLogo, /*NewActivityIcon*/},
  props: {
    activity: Object,
    styleType: String,
    hideStar: Boolean,
    interactable: Boolean,
    hideTitle: {
      type: Boolean,
      default: false
    },
    hideTimestamp: {
      type: Boolean,
      default: false
    }
  },
  mixins: [ QuestTypeHelper, DateFormatter ],
  computed: {
    PrettyName() {
      return PrettyName
    },
    questType()
    {
      return this.activity.quest.type;
    },
    formattedTime()
    {
      if (this.activity.plannedDate)
      {
        return this.formatHourMinutes(this.activity.plannedDate);
      }
      else
      {
        return "";
      }
    },
    recentActivity() {
      let date = this.quest?.publicationStatus?.lastPublicationDate;
      if (!date) return false;

      const oneWeekMs = 7 * 24 * 60 * 60 * 1000;
      return date.getTime() > Date.now() - oneWeekMs;
    }
  },
  methods: {
    loadActivity()
    {
      if (this.interactable) {
        /*
        if (this.activity?.plannedDate) {
          this.$router.push({
            name: "plan-activity", params: {
              id: this.activity.id
            }
          });
        }
         else {
         */
          this.$router.push({
            name: "activity-detailed", params: {
              id: this.activity.id
            }
          });
        }
      //}
    }
  }
}
</script>

<style lang="scss" scoped>
.activity
{
  //background-color: white;
  border-radius: 5px;
  box-shadow: $default-shadow;
  margin-bottom: 0.66rem;
  display: flex;

  height: 50px;

  .icon-container
  {
    min-width: 50px;
    overflow: visible;

    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;

    svg
    {
      fill: $font-light;
    }
  }

  .title
  {
    padding: 10px;
    flex: 1 1;

    display: flex;
    flex-direction: row;

    justify-content: flex-start;
    align-items: center;

    font-size: 0.875rem;
    font-weight: 500;

    min-width: 0; // To make the ellipsis work https://css-tricks.com/flexbox-truncated-text/

    span
    {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-right: 5px;
    }

    .timestamp
    {
      overflow: inherit;
      color: $primary-blue;
      font-style: italic;
      font-weight: 400;
    }
  }

  .score
  {
    font-weight: 500;
    margin-right: 15px;
  }

  .no-star .fa-star
  {
    display: none;
  }

  &.no-timestamp .timestamp
  {
    display: none;
  }


  &.full-color
  {
    //background-color: !important;
    .title, .score
    {
      color: white;
      font-weight: bold;
    }

    .energy-icon
    {
      fill: white;
    }
  }
}

.bg-black
{
  background-color: #000000;
}

.pointer
{
  cursor: pointer;
}
</style>